import isEmpty from 'lodash/isEmpty';

import { getRandomImage } from '../utils/lateralImage';

export const SET_LATERAL_IMAGE = 'setLateralImage';
export const setLateralImage = ({ lateralImage }) => ({
    type: SET_LATERAL_IMAGE,
    payload: lateralImage,
});

/**
 * SSR was setting the background class before loading the app and then it was
 * not updating to the correct one.
 * Setting the image on load allow us to prevent this issue causing the imagen
 * and attribution to be mixed while also allowing us to render the image
 * whenever we need it when tackling performance issues.
 */
export const pickAndSetLateralImage = () => (dispatch, getState) => {
    const {
        frontend: { lateralImage },
    } = getState();

    if (isEmpty(lateralImage)) {
        const newLateralImage = getRandomImage();

        dispatch(setLateralImage({ lateralImage: newLateralImage }));
    }
};
